/** @format */
import { useQuery } from '@tanstack/react-query';

import { Milliseconds } from '@toucan/client/global/application';
import { MarketCode } from '@toucan/client/global/market';
import { ProductSummaryV2 } from '@toucan/client/global/product';

import { getProductSummary } from '@toucan/client/core/product';

export const useProductSummary = (productId: number, market: MarketCode) => {
    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Legacy code: do not use as an example.
    return useQuery<ProductSummaryV2>({
        queryKey: ['product-summary', productId],
        queryFn: () => getProductSummary(productId, market),
        staleTime: Milliseconds.ONE_HOUR,
    });
};
